export enum ReportFormat {
  Csv = 'csv',
  Excel = 'xlsx',
  Pdf = 'pdf',
  PowerPoint = 'powerpoint',
  Word = 'docx',
  Img = 'img',
}

export enum AsyncActivity {
  FileDownload = `file-download`,
  QuantAnalysisFileUpload = `quant-analysis-file-upload`,
}